// =====================================================
// TYPES: USER
// Description: Types TypeScript pour les utilisateurs
// =====================================================

export type UserRole = 'superadmin' | 'admin' | 'user';

/**
 * Rôle tel que lu en base pour l'écran Utilisateurs : `none` = compte sans rôle
 * CRM, qui n'a accès à aucune donnée (TICKET-SEC-07, 00308).
 */
export type UserRoleOrNone = UserRole | 'none';

export interface User {
  id: string;
  email: string;
  full_name: string;
  role: UserRoleOrNone;
  created_at: string;
  last_sign_in_at?: string;
  last_active_at?: string;
}

export interface UpdateUserDto {
  role?: UserRole;
}

export interface ChangePasswordDto {
  newPassword: string;
}

export const USER_ROLES: UserRole[] = ['admin', 'user'];
export const ALL_USER_ROLES: UserRole[] = ['superadmin', 'admin', 'user'];

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  superadmin: 'Admin',
  admin: 'Désertours',
  user: 'Asso 4L',
};

export const NO_ROLE_LABEL = 'Sans rôle';
